// src/components/steps/ProfessionalInfo.js
import React from "react";
import { Row, Col, Form, Input } from "antd";
import PhotoUploader from "../PhotoUploader";

/**
 * Props:
 *  - photoList, setPhotoList  (pass from parent)
 */
export default function ProfessionalInfo({ photoList, setPhotoList }) {
  return (
    <Row gutter={[12, 12]}>
      <Col xs={24} sm={12}>
        <Form.Item name="linked_in" label="LinkedIn" rules={[{ required: true, message: "LinkedIn is required" }]}>
          <Input placeholder="https://www.linkedin.com/in/..." />
        </Form.Item>
      </Col>

      <Col xs={24} sm={12}>
        <Form.Item name="current_employer" label="Current Employer" rules={[{ required: true, message: "Current employer required" }]}>
          <Input />
        </Form.Item>
      </Col>

      <Col xs={24} sm={12}>
        <Form.Item name="job_title" label="Job Title" rules={[{ required: true, message: "Job title required" }]}>
          <Input />
        </Form.Item>
      </Col>

      <Col xs={24} sm={12}>
        <Form.Item name="industry" label="Industry" rules={[{ required: true, message: "Industry required" }]}>
          <Input />
        </Form.Item>
      </Col>

      <Col xs={24} sm={12}>
        <Form.Item name="workplace_country" label="Workplace Country" rules={[{ required: true, message: "Workplace country required" }]}>
          <Input />
        </Form.Item>
      </Col>

      <Col xs={24} sm={12}>
        <Form.Item label="Profile Photo (required)" required>
          <PhotoUploader fileList={photoList} setFileList={setPhotoList} />
          <div style={{ color: "#6b7280", marginTop: 8 }}>Max 5MB. JPG/PNG only.</div>
        </Form.Item>
      </Col>
    </Row>
  );
}
